export const Marquee = ({ items }) => (
  <div className="relative overflow-hidden border-y border-white/5 bg-[#17171A] py-6" data-testid="brand-marquee">
    <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
      {[...items, ...items].map((t, i) => (
        <div key={i} className="flex items-center gap-10">
          <span className="font-head text-lg font-semibold text-zinc-500">{t}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-orange-500/60" />
        </div>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#17171A] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#17171A] to-transparent" />
  </div>
);
